export default {
  'pdp:reviews:heading': 'Beoordelingen',
  'pdp:reviews:details-text':
    'Door een vergelijking met onze klantendatabase controleren we of het product daadwerkelijk is gekocht. In dat geval wordt de beoordeling gemarkeerd met „Geverifieerd“.',
  'pdp:reviews:widget:sentiment-badge': 'Onze klanten zeggen',
  'pdp:reviews:widget:verified-customer': 'Geverifieerd',
  'pdp:reviews:widget:reviews': 'Beoordelingen',
  'pdp:reviews:widget:product-reviews': 'Productbeoordelingen',
  'pdp:reviews:widget:sort': 'Sorteren',
  'pdp:reviews:widget:search': 'Zoeken',
  'pdp:product-title:ratings':
    '{count, number} {count, plural, one {beoordeling} other {beoordelingen}}',
  'pdp:buy-panel:size': 'Variant',
  'pdp:buy-panel:amount': 'Aantal',
  'pdp:buy-panel:subscription': 'Abonnement',
  'pdp:buy-panel:out-of-stock': ' - Uitverkocht',
  'pdp:buy-panel:order-type:one-off': 'Eenmalige aankoop',
  'pdp:buy-panel:order-type:subscription': 'Bespaar-abonnement',
  'pdp:buy-panel:order-type:subscription:test-message':
    '-{discount}% op je 1e bestelling, altijd -10% vanaf je 2e bestelling. Je abonnement kun je op elk moment wijzigen, pauzeren of opzeggen.',
  'pdp:buy-panel:order-type:subscription:cut-out': '{value}',
  'pdp:buy-panel:order-type:subscription:cut-out-active': '{value} abonnement actief',
  'pdp:buy-panel:subscription-interval:sub-title':
    'op elk moment te wijzigen, te pauzeren of op te zeggen',
  'pdp:buy-panel:subscription-intervals:2-weeks': '2 weken',
  'pdp:buy-panel:subscription-intervals:4-weeks': '4 weken',
  'pdp:buy-panel:subscription-intervals:6-weeks': '6 weken',
  'pdp:buy-panel:subscription-intervals:8-weeks': '8 weken',
  'pdp:buy-panel:subscription-intervals:2-weeks-test': 'Levering elke 2 weken',
  'pdp:buy-panel:subscription-intervals:4-weeks-test': 'Levering elke 4 weken',
  'pdp:buy-panel:subscription-intervals:6-weeks-test': 'Levering elke 6 weken',
  'pdp:buy-panel:subscription-intervals:8-weeks-test': 'Levering elke 8 weken',

  'pdp:buy-panel:subscription-good-choice-alert-1':
    'Bespaar {value}% met onze regelmatige levering.',
  'pdp:buy-panel:subscription-good-choice-alert-2':
    'Je kunt de levering op elk moment zelf pauzeren of beëindigen.',
  'pdp:buy-panel:add-to-cart': 'In winkelwagen',
  'pdp:sticky-add-to-cart:choose-variant': 'Variant kiezen',
  'pdp:sticky-add-to-cart:from-price': 'vanaf',
  'pdp:buy-panel:added-to-cart': 'In winkelwagen gelegd',
  'pdp:buy-panel:back-in-stock': 'Stel me op de hoogte!',
  'pdp:buy-panel:product-out-stock': 'Uitverkocht',
  'pdp:buy-panel:preorder': 'Nu vooruitbestellen',
  'pdp:buy-panel:price-per-kilo': 'komt overeen met:',
  'pdp:buy-panel:shipping-time': 'Levertijd: {value} werkdagen',
  'pdp:buy-panel:pre-order-shipping-date': 'Levering {value}',
  'pdp:buy-panel:back-in-stock:title': 'Stel me op de hoogte zodra het product weer beschikbaar is',
  'pdp:buy-panel:back-in-stock:description':
    'Vul hier je e-mailadres in en we stellen je op de hoogte zodra we dit product weer op voorraad hebben.',
  'pdp:buy-panel:back-in-stock:cta': 'Verzenden',
  'pdp:buy-panel:back-in-stock:terms':
    'We stellen je op de hoogte zodra het beschikbaar is. We delen je e-mailadres met niemand anders.',
  'pdp:content:tabs:product-information-title': 'Productinformatie',
  'pdp:included-products': 'bestaat uit',

  'pdp:buy-panel:free-shipping-new-customer':
    '<div><strong>Gratis verzending</strong><p> voor nieuwe klanten</p></div>',
  'pdp:buy-panel:free-shipping-new-customer:without-style': 'Gratis verzending voor nieuwe klanten',

  'pdp:buy-panel:free-shipping-existing-customer':
    '<div><strong>Gratis verzending</strong><p> vanaf €60 bestelwaarde</p></div>',
  'pdp:buy-panel:free-shipping-existing-customer:without-style':
    'Gratis verzending vanaf €60 bestelwaarde',

  'pdp:buy-panel:savings-banner-description':
    'Goede keuze! Je <span>bespaart {formattedSaving} per jaar!</span> Nice!',

  'pdp:buy-panel:coupon-price-personalization:discount-percentage':
    '{couponName} tegoedbon toegepast (-{discount}%)',

  'pdp:buy-panel:coupon-price-personalization:mov-info':
    'Tegoedbon geldt voor bestellingen vanaf €{mov} bestelwaarde',

  'pdp:buy-panel:recommended-alternative:title': 'Probeer eens dit alternatief:',

  'common:one-time-purchase:title': 'Eenmalige levering',

  'pdp:subscription-confirmation-information:sub-number': 'Abonnement ({aboId})',
  'pdp:subscription-confirmation-information:success': 'Succesvol toegevoegd',
  'pdp:subscription-confirmation-information:interval': 'Levering: ',
  'pdp:subscription-confirmation-information:next-delivery': 'Volgende levering: ',
  'pdp:subscription-confirmation-information:cta:manage-subscription': 'Abonnement beheren',
  'pdp:subscription-confirmation-information:cta:continue-shopping': 'Verder winkelen',
  'pdp:AddToExistingSubscriptionButton:added-successfully': 'Succesvol toegevoegd',
  'pdp:AddToExistingSubscriptionButton:do-you-have-sub':
    'Heb je al een abonnement? Log dan gewoon in, voeg het toe aan je abonnement en bespaar.',
  'pdp:AddToExistingSubscriptionButton:add-to-sub:one-off': 'Met het abonnement laten leveren',
  'pdp:AddToExistingSubscriptionButton:add-to-sub:subscription': 'Aan abonnement toevoegen',
  'pdp:AddToExistingSubscriptionButton:please-choose-your-abo': 'Kies je abonnement',
  'pdp:AddToExistingSubscriptionButton:shipping': 'Levering',
  'pdp:subscription-confirmation-information:limited-items':
    'Het is nog niet van jou! Om ervoor te zorgen dat het product zeker in je levering terechtkomt, kies je in <b>"Abonnement beheren"</b> de optie <b>"Direct uitvoeren"</b>',

  'pdp:buy-panel:eta-communication:days': 'Het product is op {eta} weer beschikbaar.',
  'pdp:buy-panel:eta-communication:weeks':
    'Het product is over {eta} {eta, plural, one {week} other {weken}} weer beschikbaar.',
  'pdp:buy-panel:eta-communication:months':
    'Het product is over {eta} {eta, plural, one {maand} other {maanden}} weer beschikbaar.',
  'pdp:buy-panel:eta-communication:unknown':
    'Het product is voor onbepaalde tijd niet beschikbaar.',

  'pdp:gallery:product-video': 'Productvideo',
};
